// extracted by mini-css-extract-plugin
export default {"copy-text-container":"mhHoPoLVlGZIOHEGqP1p","copy-text-container--single-line":"dsx1JB2RMTozBPK0ox3W","end-adornment-button":"k80BdP3mTqWFV2LXdWIr"};